import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const ingrRoleGuard: CanActivateFn = () => {
  const router = inject(Router);
  const role = localStorage.getItem('role');

  if (role === 'ingr') {
    return router.parseUrl('/simulador');
  }
  return true;
};
